import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-yes-no-toggle',
  templateUrl: './yes-no-toggle.component.html',
  styleUrls: ['./yes-no-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YesNoToggleComponent implements OnInit {
  @Input() control?: FormControl;
  @Input() label: null;
  
  @ViewChild('checkBox', {static:true}) checkBox: ElementRef;
  @Output() valueChanged: EventEmitter<boolean> = new EventEmitter(); 

  /**
   *
   */
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {    
    this.control.statusChanges
    .pipe((untilDestroyed(this)))
    .subscribe(v => this.cdr.markForCheck());
  }
 
  yesClicked(): void {
    this.checkBox.nativeElement.checked = false;
    this.control?.setValue(true);
    this.valueChanged.next(true);
  }

  noClicked(): void {
    this.checkBox.nativeElement.checked = true;
    this.control?.setValue(false);
    this.valueChanged.next(false);
  }

  test() {
    this.control.markAsTouched();
    this.control.updateValueAndValidity();
  }
  
}
